// Same-origin by default: nginx proxies /v1 to the API container
export const apiBaseUrl = process.env.REACT_APP_API_URL || "/v1";
